import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import MembershipListServices from '../../services/MembershipListServices';

function Membership({ membership, closeModal, onSuccess }) {

  const [formValues, setFormValues] = useState({
    categoryId: '',
    name: '',
    price: '',
    offerPrice: '',
    endDate: "",
    durationDays: '',
    description: '',
    maxOrdersPerDay: '',
    self_subscription_bonus: '',
    refer_subscription_bonus: '',
    maxDiscountPerOrder: '',
    discountPercent: '',
    image: null,
  });

  const [services, setServices] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);
  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const categoryRes = await MembershipListServices.getMembershipCategory();

      const categoryData = categoryRes?.data || [];

      const formattedServices = categoryData
        .filter(item => item.name)
        .map(item => ({
          _id: item._id,
          name: item.name
        }));

      setServices(formattedServices);

      console.log("MembershipCategory:", formattedServices);

    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };



  // ✅ FIXED HERE
  useEffect(() => {
    if (membership) {
      setFormValues({
        categoryId: membership?.categoryId?._id || '',
        name: membership?.name || '',
        price: membership?.price || '',
        self_subscription_bonus: membership?.self_subscription_bonus ?? '',
        refer_subscription_bonus: membership?.referral_subscription_bonus || '',
        endDate: membership?.endDate
          ? membership.endDate.split('T')[0]
          : '',
        durationDays: membership?.durationDays || '',
        description: membership?.description || '',
        maxOrdersPerDay: membership?.benefits?.maxOrdersPerDay || '',
        maxDiscountPerOrder: membership?.benefits?.maxDiscountPerOrder || '',
        discountPercent: membership?.benefits?.discountPercent || '',
        offerPrice: membership?.offer_price || '',
      });
      if (membership?.image) {
           setImagePreview([membership.image]);
      } else {
        setImagePreview([]);
      }
    }
  }, [membership]);
 const handleImageChange = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  setFormValues((prev) => ({ ...prev, image: file }));
  setImagePreview([URL.createObjectURL(file)]); // ✅ Naya preview generate hoga
};

  const removeImage = () => {
    setFormValues((prev) => ({ ...prev, image: null }));
    setImagePreview([]);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const membershipId = membership?._id;

  const handleNumberInput = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleNumberPaste = (e) => {
    const pasteData = e.clipboardData.getData('text');
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!membershipId) {
      return;
    }

    try {

      const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };
      // const data = {
      //   categoryId: formValues.categoryId,
      //   name: formValues.name,
      //   price: Number(formValues.price),
      //   self_subscription_bonus: Number(formValues.self_subscription_bonus),
      //   referral_subscription_bonus: Number(formValues.refer_subscription_bonus),
      //   offer_price: Number(formValues.offerPrice) || 0,
      //   endDate: formValues.endDate,
      //   durationDays: formValues.durationDays,
      //   description: formValues.description,
      //   ...(isPremium && { endDate: formValues.endDate }),
      //   ...(isPrime && { durationDays: Number(formValues.durationDays) }),
      //   benefits: {
      //     maxOrdersPerDay: formValues.maxOrdersPerDay,
      //     maxDiscountPerOrder: formValues.maxDiscountPerOrder,
      //     discountPercent: formValues.discountPercent,

      //   }
      // };
      const formData = new FormData();

      const appendIf = (key, value, isNumber = false) => {
        if (value !== undefined && value !== null && value !== '') {
          formData.append(key, isNumber ? Number(value) : value);
        }
      };

      appendIf('categoryId', formValues.categoryId);
      appendIf('name', formValues.name);
      appendIf('price', formValues.price, true);
      appendIf('self_subscription_bonus', formValues.self_subscription_bonus, true);
      appendIf('referral_subscription_bonus', formValues.refer_subscription_bonus, true);
      appendIf('offer_price', formValues.offerPrice, true);
      appendIf('endDate', formValues.endDate);
      appendIf('durationDays', formValues.durationDays, true);
      appendIf('description', formValues.description);

      // conditional (same as your original spread)
      // if (isPremium) appendIf('endDate', formValues.endDate);
      if (isPrime) appendIf('durationDays', formValues.durationDays, true);

      // benefits (nested — backend ke hisaab se adjust karein)
      appendIf('benefits[maxOrdersPerDay]', formValues.maxOrdersPerDay, true);
      appendIf('benefits[maxDiscountPerOrder]', formValues.maxDiscountPerOrder, true);
      appendIf('benefits[discountPercent]', formValues.discountPercent, true);

      // image
      if (formValues.image) {
        formData.append('image', formValues.image);
      }

      await MembershipListServices.updateMemberships(membership._id, formData);
      alert('Membership updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update Membership', error);
      alert('Failed to update Membership');
    }
  };


  useEffect(() => {
    if (isPremium) {
      setFormValues(prev => ({ ...prev, durationDays: '' }));
    }

    if (isPrime) {
      setFormValues(prev => ({ ...prev, endDate: '' }));
    }
  }, [formValues.categoryId]);

  const selectedCategory = services.find(
    (item) => item._id === formValues.categoryId
  );

  const categoryName = selectedCategory?.name;

  const isPremium = categoryName === "PLATINUM";
  const isPrime = categoryName === "PRIME";
  return (
    <div className="modal fade edit-box show d-block" id="editModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit Membership</h5>
            <button type="button" className="btn-close" onClick={closeModal} />
          </div>

          <div className="modal-body">
            <div className="container-box px-5">
              <div className="page-details">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    {/* Membership Category Dropdown */}
                    <div className="input-field">
                      <label>Select Membership Category *</label>
                      <select
                        name="categoryId"
                        value={formValues.categoryId}
                        onChange={handleInputChange}
                        className="form-control"

                      >
                        <option value="">Select Membership Category</option>
                        {services.map(service => (
                          <option key={service._id} value={service._id}>
                            {service.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="input-field">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formValues.name}
                        onChange={handleInputChange}
                        className="form-control"

                      />
                    </div>

                    <div className="input-field">
                      <label>Price</label>
                      <input
                        type="number"
                        name="price"
                        value={formValues.price}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"

                      />
                    </div>
                    <div className="input-field">
                      <label>Offer Price</label>
                      <input
                        type="number"
                        name="offerPrice"
                        value={formValues.offerPrice}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                      />
                    </div>
                    <div className="input-field">
                      <label>Self Subscription Bonus<span className=""></span></label>
                      <input
                        type="number"
                        name="self_subscription_bonus"
                        value={formValues.self_subscription_bonus}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                        placeholder='Enter Offer'
                      />
                    </div>
                    <div className="input-field">
                      <label>Refer Subsription Bonus<span className=""></span></label>
                      <input
                        type="number"
                        name="refer_subscription_bonus"
                        value={formValues.refer_subscription_bonus}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                        placeholder='Enter Offer'
                      />
                    </div>
                    <div className="input-field">
                      <label>Duration Days</label>
                      <input
                        type="number"
                        name="durationDays"
                        value={formValues.durationDays}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                      />
                    </div>
                    {/* Premium */}
                    {/* Premium */}
                    {isPremium && (
                      <div className="input-field">
                        <label>End Date</label>
                        <input
                          type="date"
                          name="endDate"
                          value={formValues.endDate}
                          onChange={handleInputChange}
                          className="form-control"

                        />
                      </div>
                    )}

                    {/* Prime */}
                    {isPrime && (
                      <div className="input-field">
                        <label>Duration Days</label>
                        <input
                          type="number"
                          name="durationDays"
                          value={formValues.durationDays}
                          onChange={handleInputChange}
                          onKeyDown={handleNumberInput}
                          onPaste={handleNumberPaste}
                          className="form-control"

                        />
                      </div>
                    )}

                    <div className="input-field">
                      <label>Description</label>
                      <textarea
                        name="description"
                        value={formValues.description}
                        onChange={handleInputChange}
                        className="form-control"

                        style={{ height: "100px" }}
                      />
                    </div>
                   <div className="col-lg-12 mt-3">
  <label>Image</label>
  <input
    type="file"
    onChange={handleImageChange}
    className="form-control"
    accept="image/*"
  />

  {imagePreview.length > 0 && (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
      {imagePreview.map((img, i) => {
        // ✅ CHECK: Agar naya file select hua hai (blob) toh direct, warna purane path me base url add karo
        const imageUrl = (img.startsWith('blob:') || img.startsWith('http')) 
            ? img 
            : `${process.env.REACT_APP_URL}${img}`;

        return (
          <div key={i} style={{ position: 'relative', display: 'inline-block', border: '1px solid #ddd', padding: '4px', borderRadius: '6px' }}>
            <img
              src={imageUrl} // ✅ yahan sahi URL aayega
              width="90"
              height="90"
              style={{ objectFit: 'cover', borderRadius: '4px' }}
              alt="Preview"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/img/placeholder-img.png';
              }}
            />
            {/* <button
              type="button"
              onClick={removeImage}
              style={{
                position: 'absolute',
                top: '-8px',
                right: '-8px',
                background: '#dc3545',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '22px',
                height: '22px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}
              title="Remove Image"
            >
              ×
            </button> */}
          </div>
        );
      })}
    </div>
  )}
</div>

                  


                    {/* <div className="input-field">
                      <label>Max Orders Per Day</label>
                      <input
                        type="number"
                        name="maxOrdersPerDay"
                        value={formValues.maxOrdersPerDay}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                
                      />
                    </div> */}

                    {/* <div className="input-field">
                      <label>Max Discount Per Order</label>
                      <input
                        type="number"
                        name="maxDiscountPerOrder"
                        value={formValues.maxDiscountPerOrder}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                
                      />
                    </div> */}

                    {/* <div className="input-field">
                      <label>Discount Percent</label>
                      <input
                        type="number"
                        name="discountPercent"
                        value={formValues.discountPercent}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                 
                      />
                    </div> */}
                    </div> 

               

                  <button className="submit-green-btn">Submit</button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Membership;